/*
* @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「单选选择框」
 * @modify Date:2021-2-17 16:43
 */

<template>
  <div class="cSingleChoice-container">
    <li
      v-for="(item, index) in selectdata"
      :key="index"
      @click="handelSelect(item)"
      class="select-item"
      :class="{
        'select-noactive': !item.isActive && !noChoose,
        'select-active': item.isActive && !noChoose,
        'select-num': rankNum && rankNum == 2,
        'select-num1': rankNum && rankNum == 3
      }"
    >
      {{ item.value }}
    </li>
  </div>
</template>

<script>
export default {
  props: ['selectdata', 'rankNum', 'needIndex', 'index'],
  //rankNum :一行排列2个的样式
  //用于回传index
  data() {
    return {
      noChoose: this.handelIsChoose()
    };
  },
  watch: {
    selectdata() {
      this.noChoose = this.handelIsChoose();
    }
  },
  methods: {
    handelSelect(item) {
      if (this.needIndex) {
        this.$emit('selectClick', item, this.index);
      } else {
        this.$emit('selectClick', item);
      }
    },
    // 判断已进入页面是否有选择
    handelIsChoose() {
      return this.selectdata.every((item) => {
        return !item.isActive;
      });
    }
  }
};
</script>

<style lang='less' scoped>
.cSingleChoice-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .select-item {
    cursor: pointer;
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    text-align: center;
    font-size: 0.16rem;
    color: var(--text-blackcolor);
    background-color: var(--bg-pinkcolor);
    border: 2px solid var(--maincolor);
    border-radius: 0.05rem;
    margin-bottom: 0.11rem;
    font-weight: bold;
  }
  .select-noactive {
    color: var(--text-graycolor);
    border: 2px solid #adadad;
    background-color: #fff;
  }
  .select-active {
    background-color: var(--maincolor);
    color: #fff;
  }
  .select-num {
    width: calc((100% - 0.2rem) / 2);
  }
  .select-num1 {
    width: calc((100% - 0.25rem) / 3);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Select/cSingleChoice.vue